import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Loading from '../../components/loading';
import EssayMediaModal from './components/modal/EssayMediaModal';
import EssayTypeModal from './components/modal/EssayTypeModal';
import ThemeHighlight from './components/theme-highlight';
import ThemeItem from './components/theme-item';
import { EssayViewModel } from './essay.vm';
import {
  Breadcrumb,
  Container,
  EssayList,
  EssayListContainer,
  EssaySubTitle,
  EssayTitleWrapper,
  Title,
} from './styles';

const DESKTOP_COLUMNS = 4;
const TABLET_COLUMNS = 3;
const MOBILE_COLUMNS = 1;
const DESKTOP_DISPLAY_LENGTH = 4;
const TABLET_DISPLAY_LENGTH = 3;
const MOBILE_DISPLAY_LENGTH = 3;

export const AllTopics: React.FC = () => {
  const vm = useViewModel(EssayViewModel);
  const navigate = useNavigate();

  const [, setDisplayLength] = useState(DESKTOP_DISPLAY_LENGTH);
  const [columns, setColumns] = useState(DESKTOP_COLUMNS);

  const openEssay = () => {
    navigate('/essays');
  };

  useEffect(() => {
    if (vm.hasError) {
      navigate('/library');
    }
  }, [vm.hasError, navigate]);

  useEffect(() => {
    const updateLayout = () => {
      const width = window.innerWidth;
      if (width <= 640) {
        setColumns(MOBILE_COLUMNS);
        setDisplayLength(MOBILE_DISPLAY_LENGTH);
      } else if (width <= 1024) {
        setColumns(TABLET_COLUMNS);
        setDisplayLength(TABLET_DISPLAY_LENGTH);
      } else {
        setColumns(DESKTOP_COLUMNS);
        setDisplayLength(DESKTOP_DISPLAY_LENGTH);
      }
    };

    window.addEventListener('resize', updateLayout);
    updateLayout();

    return () => {
      window.removeEventListener('resize', updateLayout);
    };
  }, []);

  if (vm.isLoading || !vm.essayThemes || !vm.essays || !vm.essayHighlight) {
    return <Loading />;
  }

  const essayThemeItemsArray = vm.essayThemes;

  return (
    <Container>
      <Breadcrumb onClick={() => openEssay()}>Redação / Minhas redações</Breadcrumb>
      <Title>Redação</Title>

      <EssayListContainer>
        <Breadcrumb onClick={() => openEssay()}> {`< Voltar`}</Breadcrumb>
        <EssayTitleWrapper>
          <EssaySubTitle>Temas de redação</EssaySubTitle>
        </EssayTitleWrapper>
        <EssayList columns={columns}>
          {vm?.essayHighlight.length > 0 && (
            <ThemeHighlight
              columns={columns}
              themeGuid={vm.essayHighlight[0]?.topic.id}
              themeOrigin={vm.essayHighlight[0]?.type.name}
              themeTitle={vm.essayHighlight[0]?.topic.name}
              exampleEssay={null}
              themeCover={vm.essayHighlight[0]?.topic?.imageUrl}
            />
          )}
          {essayThemeItemsArray.map((theme, i) => (
            <ThemeItem
              key={i}
              themeGuid={theme.id}
              themeOrigin={theme?.type?.name || '-'}
              themeTitle={theme.name}
              themeCover={theme.imageUrl}
              motivationalTexts={theme.motivationalTexts}
            />
          ))}
        </EssayList>
      </EssayListContainer>
      <EssayTypeModal
        onClose={() => vm.setIsEssayTypeModalOpen(false)}
        isOpen={vm.isEssayTypeModalOpen}
      />
      <EssayMediaModal
        onClose={() => vm.setIsEssayMediaModalOpen(false)}
        isOpen={vm.isEssayMediaModalOpen}
      />
    </Container>
  );
};

export default observer(AllTopics);
